/**
 * Wrappers cacheados de los endpoints de catalogos.
 *
 * Sirven como reemplazo drop-in de las APIs originales:
 *   - Antes: tiposServicioAPI.getAll()
 *   - Despues: getCachedTiposServicio()
 *
 * Cuando una mutacion ocurre, llamar la funcion `invalidate*` correspondiente
 * para que la proxima lectura sea fresh:
 *   - Crear/editar/borrar tipo de servicio: invalidateTiposServicio()
 *   - Crear/editar/borrar personal: invalidatePersonal()
 *   - etc.
 *
 * Las KEYS son strings unicas que identifican cada catalogo en el cache.
 */
import {
    tiposServicioAPI,
    personalAPI,
    costosFijosAPI,
    plantillasAPI,
    clientesAPI,
    usuariosAPI,
    categoriasAPI
} from './api';
import { cached, invalidateMany } from './catalogCache';

// ============ TIPOS DE SERVICIO ============
export const getCachedTiposServicio = () =>
    cached('tipos-servicio', () => tiposServicioAPI.getAll());

export const getCachedTiposServicioGrouped = () =>
    cached('tipos-servicio-grouped', () => tiposServicioAPI.getGrouped());

export const invalidateTiposServicio = () =>
    invalidateMany(['tipos-servicio', 'tipos-servicio-grouped']);

// ============ PERSONAL ============
export const getCachedPersonal = () =>
    cached('personal', () => personalAPI.getAll());

export const invalidatePersonal = () =>
    invalidateMany(['personal']);

// ============ COSTOS FIJOS ============
export const getCachedCostosFijos = () =>
    cached('costos-fijos', () => costosFijosAPI.getAll());

export const getCachedCostosFijosGrouped = () =>
    cached('costos-fijos-grouped', () => costosFijosAPI.getGrouped());

export const invalidateCostosFijos = () =>
    invalidateMany(['costos-fijos', 'costos-fijos-grouped']);

// ============ PLANTILLAS ============
export const getCachedPlantillas = () =>
    cached('plantillas', () => plantillasAPI.getAll());

export const invalidatePlantillas = () =>
    invalidateMany(['plantillas']);

// ============ CLIENTES ============
export const getCachedClientes = () =>
    cached('clientes', () => clientesAPI.getAll());

export const invalidateClientes = () =>
    invalidateMany(['clientes']);

// ============ USUARIOS ============
export const getCachedUsuarios = () =>
    cached('usuarios', () => usuariosAPI.getAll());

export const invalidateUsuarios = () =>
    invalidateMany(['usuarios']);

// ============ CATEGORIAS ============
export const getCachedCategorias = () =>
    cached('categorias', () => categoriasAPI.getAll());

export const invalidateCategorias = () =>
    invalidateMany(['categorias']);
